export default __webpack_public_path__ + "static/retirement-icon-7d62e1efac5ad27434d47055597ccb31.svg";